import * as THREE from 'three';
import { labelPlane, roundedBox } from '../materials/MaterialFactory';

export class Breadboard extends THREE.Group {
  constructor() {
    super();
    this.name = '实验底板';
    const board = new THREE.Mesh(
      roundedBox(24, 12.5, 0.55, 0.55),
      new THREE.MeshStandardMaterial({ color: 0xe8edf0, roughness: 0.72, metalness: 0.06 })
    );
    board.rotation.x = -Math.PI / 2;
    board.receiveShadow = true;
    this.add(board);

    const groove = new THREE.Mesh(
      new THREE.BoxGeometry(21.5, 0.035, 0.42),
      new THREE.MeshStandardMaterial({ color: 0x89939d, roughness: 0.8 })
    );
    groove.position.set(0, 0.33, 0);
    this.add(groove);

    const holeGeo = new THREE.CylinderGeometry(0.055, 0.055, 0.07, 8);
    holeGeo.rotateX(Math.PI / 2);
    const holeMat = new THREE.MeshBasicMaterial({ color: 0x26333c });
    for (let x = -10.5; x <= 10.5; x += 0.55) {
      for (const z of [-4.85, -4.3, -3.75, -2.3, -1.75, 1.75, 2.3, 3.75, 4.3, 4.85]) {
        const hole = new THREE.Mesh(holeGeo, holeMat);
        hole.position.set(x, 0.37, z);
        this.add(hole);
      }
    }
    const vcc = labelPlane(['VCC  +'], 2.6, 0.42, { background: '#f0f3f5', color: '#d51f39', accent: '#d51f39' });
    vcc.rotation.x = -Math.PI / 2;
    vcc.position.set(-9.5, 0.39, -5.55);
    this.add(vcc);
    const gnd = labelPlane(['GND  −'], 2.6, 0.42, { background: '#f0f3f5', color: '#29313a', accent: '#29313a' });
    gnd.rotation.x = -Math.PI / 2;
    gnd.position.set(-9.5, 0.39, 5.55);
    this.add(gnd);
  }
}
